import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  // the api only ever returns the logged in user's own favorites
  list (context) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/usersystemfavorite')
        .then(({ data }) => {
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ==========================Socket Updates==============================
  // a star set or cleared in another tab: the socket only carries the record id, so re-read the list
  created (context, opts) {
    context.dispatch('list').catch(() => {})
  },
  updated (context, opts) {
    context.dispatch('list').catch(() => {})
  },
  destroyed (context, opts) {
    context.dispatch('list').catch(() => {})
  },
  // ===========================List Edits===============================
  // opts: { system }
  add (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/usersystemfavorite', opts)
        .then(({ data }) => {
          context.commit('LIST_ADD', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  delete (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/usersystemfavorite/${opts}`)
        .then(({ data }) => {
          context.commit('LIST_REMOVE', opts)
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
